import { createApp } from "vue";

import App from "./App.vue";
import { registerPlugins } from "./plugins";
import "./services/api/api";

const app = createApp(App);
registerPlugins(app);
app.mount("#app");
